import { Button, Drawer } from "@mui/material";
import { useEffect, useState } from "react";
import { FiArrowLeft } from "react-icons/fi";
import { IoIosArrowDown } from "react-icons/io";
import { useIntl } from "react-intl";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { fetchDemoCompanyGame } from "../auth/api/loginapi";
import { GameItem } from "../common/components/GameListing";
import GridIcon from "../common/components/gridIcon/GridIcon";

export const DemoGameListingPage = () => {
    const { companyCode } = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const intl = useIntl();

    const [gameList, setGameList] = useState([]);
    const [companyList, setCompanyList] = useState([]);
    const [openCompanyList, setOpenCompanyList] = useState(false);
    const [loading, setLoading] = useState(true);
    const [gameName, setGamename] = useState("");
    const [selectedGame, setSelectedGame] = useState(null);
    const [gamePerRow, setGamePerRow] = useState(
        localStorage.getItem("gamePerRow")
            ? parseInt(localStorage.getItem("gamePerRow"))
            : 4
    );

    useEffect(() => {
        setLoading(true);
        fetchDemoCompanyGame(companyCode)
            .then((res) => {
                if (res) {
                    if (res.demoSlotGameLists) {
                        setGameList(res.demoSlotGameLists);
                    } else {
                        setGameList([]);
                    }
                    if (res.demoCompanyLists) {
                        setCompanyList(res.demoCompanyLists);
                    }
                }
            })
            .finally(() => setLoading(false));
    }, [companyCode]);

    const handlePlayGame = (gamecode) => {
        navigate(`/gamePlay/${companyCode}/${gamecode}/0/0/slot`);
    };

    return (
        <div className="d-flex flex-column container-fluid px-0 h-100 min-vh-100" style={{ backgroundColor: "#1c1e23" }}>
            <div style={styles.navBar} className="position-relative w-100">
                <div
                    style={styles.backButton}
                    className="cursor-pointer"
                    onClick={() => navigate("/")}
                >
                    <FiArrowLeft style={{ color: "white", cursor: "pointer" }} />
                </div>
                <div
                    style={{ ...styles.title, cursor: "pointer" }}
                    className="text-font4 d-flex align-items-center"
                    onClick={() => setOpenCompanyList(true)}
                >
                    {companyList.find((c) => c.companycode === companyCode)?.companyname} {intl.formatMessage({ id: "demo" })}
                    <IoIosArrowDown style={{ paddingLeft: "5px" }} size={20} />
                </div>
            </div>
            <div style={{ height: "10px" }}></div>
            <div
                style={{
                    width: "95%",
                    margin: "0 auto",
                    paddingTop: "5px",
                    paddingBottom: "6vh",
                }}
            >
                <div className="d-flex align-items-center gap-2 mb-3">
                    <div className="input-group flex-fill">
                        <input
                            type="text"
                            className="form-control text-font2 py-1"
                            placeholder={intl.formatMessage({ id: "search" })}
                            aria-describedby="basic-addon1"
                            value={gameName}
                            onChange={(e) => setGamename(e.target.value)}
                        />
                        <span className="input-group-text" id="basic-addon1">
                            <i className="fa fa-search" />
                        </span>
                    </div>
                    <GridIcon
                        columns={gamePerRow === 4 ? 3 : 4}
                        onClick={() => {
                            localStorage.setItem("gamePerRow", gamePerRow === 4 ? 3 : 4);
                            setGamePerRow(gamePerRow === 4 ? 3 : 4);
                        }}
                    />
                </div>

                {loading ? (
                    <div className="d-flex justify-content-center align-items-center mt-5">
                        <div className="spinner-border text-warning" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                ) : (
                    <div style={{ display: "flex", flexWrap: "wrap" }}>
                        {gameList.filter((game) =>
                            game.gamename.toLowerCase().includes(gameName.toLowerCase())
                        ).length > 0 ? (
                            gameList
                                .filter((game) =>
                                    game.gamename.toLowerCase().includes(gameName.toLowerCase())
                                )
                                .map((game, index) => (
                                    <GameItem
                                        key={index}
                                        game={game}
                                        searchName={gameName}
                                        handlePlayGame={handlePlayGame}
                                        gamePerRow={gamePerRow}
                                        selectedGame={selectedGame}
                                        setSelectedGame={setSelectedGame}
                                        imageStyle={{
                                            width: "100%",
                                        }}
                                    />
                                ))
                        ) : (
                            <div
                                className="text-font3 w-100 text-center py-3 text-white"
                            >
                                {intl.formatMessage({ id: "noRecordFound" })}
                            </div>
                        )}
                    </div>
                )}
            </div>
            <Drawer
                anchor="bottom"
                open={openCompanyList}
                onClose={() => setOpenCompanyList(false)}
                style={{ minHeight: "40vh" }}
            >
                <div style={{ backgroundColor: "#1c1e23", padding: "16px" }}>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                        }}
                    >
                        <Button onClick={() => setOpenCompanyList(false)}>
                            <FiArrowLeft style={{ color: "white" }} />
                        </Button>
                        <div className="text-font3" style={{ flex: 7, color: "white" }}>
                            {intl.formatMessage({ id: "companyList" })}
                        </div>
                    </div>

                    <div
                        style={{
                            color: "white",
                            cursor: "pointer",
                            width: "100%",
                            paddingTop: "20px",
                        }}
                    >
                        {companyList &&
                            companyList.map((company, index) => (
                                <div
                                    onClick={() => {
                                        setOpenCompanyList(false);
                                        navigate(`/demo/${company.companycode}`);
                                    }}
                                    key={company.companycode || index}
                                    className="text-font2"
                                    style={{
                                        width: "100%",
                                        height: "40px",
                                        borderTop: "1px solid #262626",
                                        display: "flex",
                                        alignItems: "center",
                                    }}
                                >
                                    {company.companyname}
                                </div>
                            ))}
                    </div>
                </div>
            </Drawer>
        </div>
    );
};

const styles = {
    navBar: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "60px",
        backgroundColor: "black",
    },
    backButton: {
        position: "absolute",
        left: "15px",
        fontSize: "20px",
        zIndex: 10,
    },
    title: {
        fontWeight: "bold",
        color: "white",
        margin: "0 auto",
    },
};
